module.exports = __webpack_public_path__ + "static/img/16.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/sp/16.png
// module id = sKeg
// module chunks = 0